import axios from "axios";
import { apiCall } from "./ApiResult.model";

export interface FolderForensicChild {
  id: string;
  name: string;
  path: string;
  application: string;
}

export const getFolderForensicChildrenCount = apiCall<
  string, // folder ID
  number
>("folder-forensic.children.count", async (folderId: string) => {
  const res = await axios.get(`/folder-forensic/${folderId}/children/count`);
  return {
    success: true,
    value: res.data,
  };
});

export const getFolderForensicChildren = apiCall<
  string, // folder ID
  FolderForensicChild[]
>("folder-forensic.children.list", async (folderId: string) => {
  const res = await axios.get(`/folder-forensic/${folderId}/children`);
  return {
    success: true,
    value: res.data,
  };
});
